<template>
    <div class="nav-big">
        <topPic></topPic>
        <Product></Product>
<!--        <Research></Research>-->
    </div>
</template>

<script>
    import topPic from '../demonstration/top-picture.vue'
    import Product from '../demonstration/product.vue'
    import Research from '../demonstration/research.vue'
    export default {
        name: "index.vue",
        components:{
            topPic,Product,Research
        }
    }
</script>

<style scoped lang="scss">
</style>
